export const RIGHT_SPACE = '48px';

export const PANEL_RIGHT_OFFSET = '60px';
